import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    AI_ASSISTANT: {
        /** Title for the AI Assistant tooltip */
        title: string;
    };
    SHARE_BUTTON: {
        /** Title for share button tooltip */
        title: string;
        /** Description for share button tooltip - part 1 */
        descriptionPart1: string;
        /** Description for share button tooltip - part 2 */
        descriptionPart2: string;
    };
    UPLOAD_BUTTON: {
        /** Title for upload button tooltip */
        title: string;
        /** Description for upload button tooltip */
        description: string;
    };
    COMMENT_COMPOSER: {
        /** Title for comment composer tooltip */
        title: string;
        /** Description for comment composer tooltip */
        description: string;
    };
    ANNOTATION_BUTTON: {
        /** Title for annotation button tooltip */
        title: string;
        /** Description for annotation button tooltip */
        description: string;
    };
    FIELDS_TAB: {
        /** Title for fields tab tooltip */
        title: string;
        /** Description for fields tab tooltip */
        description: string;
    };
    TEXT_ANNOTATIONS: {
        /** Title for text annotations tooltip */
        title: string;
        /** Description for text annotations tooltip */
        description: string;
    };
    SHARE_COMMENT_COMPOSER: {
        /** Title for share comment composer tooltip */
        title: string;
        /** Description for share comment composer tooltip - part 1 */
        descriptionPart1: string;
        /** Description for share comment composer tooltip - part 2 */
        descriptionPart2: string;
    };
    SHARE_COMMENT_COMPOSER_IMAGE: {
        /** Title for share comment composer image tooltip */
        title: string;
        /** Description for share comment composer image tooltip */
        description: string;
    };
    SHARE_COMMENT_COMPOSER_PDF: {
        /** Title for share comment composer PDF tooltip */
        title: string;
        /** Description for share comment composer PDF tooltip - part 1 */
        descriptionPart1: string;
        /** Description for share comment composer PDF tooltip - part 2 */
        descriptionPart2: string;
    };
    SHARE_LINKS: {
        /** Title for share links list tooltip */
        title: string;
        /** Description for share links list tooltip */
        description: string;
        /** Label for watch video link */
        linkLabel: string;
    };
    OPEN_SHARE_LINK: {
        /** Title for open share link tooltip */
        title: string;
        /** Description for open share link tooltip */
        description: string;
    };
    ACCOUNT_MULTI_LANGUAGE: {
        /** Title for account avatar tooltip */
        title: string;
        /** Description for account avatar tooltip */
        description: string;
    };
    MOUNT_PROJECT_BUTTON: {
        /** Title for mount project button tooltip */
        title: string;
        /** Description for mount project button tooltip */
        description: string;
        /** Link label for mount project button tooltip */
        linkLabel: string;
    };
    ENABLE_MOUNTED_STORAGE_BUTTON: {
        /** Title for enable mounted storage button tooltip */
        title: string;
        /** Description for enable mounted storage button tooltip */
        description: string;
    };
    LABS_NAV: {
        /** Title for labs nav tooltip */
        title: string;
        /** Description for labs nav tooltip */
        description: string;
        /** Link label for labs nav tooltip */
        linkLabel: string;
    };
    EXPORT_SEQUENCE_BUTTON: {
        /** Title for export sequence button tooltip */
        title: string;
        /** Description for export sequence button tooltip */
        description: string;
    };
    EXPORT_COMPOSITION_BUTTON: {
        /** Title for export composition button tooltip */
        title: string;
        /** Description for export composition button tooltip */
        description: string;
    };
    SHARE_SEQUENCE_BUTTON: {
        /** Title for share sequence button tooltip */
        title: string;
        /** Description for share sequence button tooltip */
        description: string;
    };
    SHARE_COMPOSITION_BUTTON: {
        /** Title for share composition button tooltip */
        title: string;
        /** Description for share composition button tooltip */
        description: string;
    };
    SHARE_LIST: {
        /** Tooltip heading for the Save as list button in the share modal */
        title: string;
        /** Tooltip body explaining that share lists let you invite multiple collaborators at once */
        description: string;
        /** Button label to dismiss the Save as list tooltip */
        actionLabel: string;
    };
    CREATE_UPLOAD_LINK: {
        /** Title for the create upload link tooltip */
        title: string;
        /** Description explaining what upload links do */
        description: string;
        /** Button label to dismiss the create upload link tooltip */
        actionLabel: string;
    };
    CUSTOM_SHORTCUTS_CAPTURE: {
        /** Title for the custom-shortcuts discovery tooltip */
        title: string;
        /** Description explaining how to edit a shortcut inline */
        description: string;
    };
    VERSION_HISTORY: {
        /** Title for the version history tooltip */
        title: string;
        /** Description explaining that Frame.io Drive saves appear in version history */
        description: string;
        /** Button label that opens the version history modal */
        viewHistoryLabel: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** AI Assistant discovery tooltip */
            AI_ASSISTANT: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the AI Assistant tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.AI_ASSISTANT.title?c=55doe04v3v9k", defaultMessage: "Open AI Assistant" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share button tooltip */
            SHARE_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_BUTTON.title?c=2srun65siveuo", defaultMessage: "Create a Share Link" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share button tooltip - part 1 */
                        descriptionPart1: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_BUTTON.descriptionPart1?c=1novvkbnmrhnd", defaultMessage: "Present your work in a customizable" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share button tooltip - part 2 */
                        descriptionPart2: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_BUTTON.descriptionPart2?c=3akyvgaf94nbh", defaultMessage: "layout. Send it to get Feedback." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Upload button tooltip */
            UPLOAD_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for upload button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.UPLOAD_BUTTON.title?c=1smttpixtuygp", defaultMessage: "Add Files to Collaborate" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for upload button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.UPLOAD_BUTTON.description?c=5sspyg0405qw", defaultMessage: "Upload files and folders you want to collaborate on." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Comment composer tooltip */
            COMMENT_COMPOSER: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for comment composer tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.COMMENT_COMPOSER.title?c=2pme4kzfqony8", defaultMessage: "Start Typing to Leave Feedback" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for comment composer tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.COMMENT_COMPOSER.description?c=1ht05gzvstcvl", defaultMessage: "Add your frame-accurate comments here." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Annotation button tooltip */
            ANNOTATION_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for annotation button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.ANNOTATION_BUTTON.title?c=24zx4jcnitxf0", defaultMessage: "Mark up a Frame" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for annotation button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.ANNOTATION_BUTTON.description?c=u8jwcweg3mbe", defaultMessage: "Use the annotation tool to highlight important areas on a frame." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Fields tab tooltip */
            FIELDS_TAB: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for fields tab tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.FIELDS_TAB.title?c=3leviem8actij", defaultMessage: "Metadata and Properties" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for fields tab tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.FIELDS_TAB.description?c=1cm8gw4fc23px", defaultMessage: "View details such as bit rate, status, and viewer history for this asset." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Text annotations tooltip */
            TEXT_ANNOTATIONS: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for text annotations tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.TEXT_ANNOTATIONS.title?c=29925qk423wju", defaultMessage: "Suggest an Edit" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for text annotations tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.TEXT_ANNOTATIONS.description?c=32erl8h3nwj0", defaultMessage: "Turn on text suggestions and begin by highlighting text." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share comment composer tooltip for video frames */
            SHARE_COMMENT_COMPOSER: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share comment composer tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER.title?c=2svv0so23wolr", defaultMessage: "Have thoughts on this frame?" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share comment composer tooltip - part 1 */
                        descriptionPart1: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER.descriptionPart1?c=3hucpgh2w6n6e", defaultMessage: "Your comments stay linked to the right moment, so the team knows exactly what you mean." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share comment composer tooltip - part 2 */
                        descriptionPart2: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER.descriptionPart2?c=qhmw02prkbta", defaultMessage: "Use C to comment at the current time." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share comment composer tooltip for images */
            SHARE_COMMENT_COMPOSER_IMAGE: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share comment composer image tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER_IMAGE.title?c=l5rkm22i3pig", defaultMessage: "Have thoughts on this asset?" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share comment composer image tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER_IMAGE.description?c=31jwyrw3z6zsa", defaultMessage: "Comment on the entire image or anchor them to a specific spot." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share comment composer tooltip for PDFs */
            SHARE_COMMENT_COMPOSER_PDF: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share comment composer PDF tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER_PDF.title?c=xgvs9iabkitn", defaultMessage: "Have thoughts on this page?" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share comment composer PDF tooltip - part 1 */
                        descriptionPart1: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER_PDF.descriptionPart1?c=1bgq8b9nuxrrq", defaultMessage: "Your comments stay linked to the right page so the team knows exactly what you mean." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share comment composer PDF tooltip - part 2 */
                        descriptionPart2: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMMENT_COMPOSER_PDF.descriptionPart2?c=pbcd2g96gv68", defaultMessage: "Use C to comment on the current page." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share links list tooltip in share builder */
            SHARE_LINKS: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share links list tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_LINKS.title?c=28kqp4avhjurx", defaultMessage: "Share Links" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share links list tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_LINKS.description?c=3vify3qyhcwr0", defaultMessage: "All the Shares you create live here. Add assets directly by dragging and dropping." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label for watch video link */
                        linkLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_LINKS.linkLabel?c=1tjvghmi18jf7", defaultMessage: "Watch the Video" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Open share link tooltip in share builder */
            OPEN_SHARE_LINK: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for open share link tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.OPEN_SHARE_LINK.title?c=3sha3sj9qfdib", defaultMessage: "View Your Share Link" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for open share link tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.OPEN_SHARE_LINK.description?c=1i6nh0yjrzal1", defaultMessage: "Open your Share or copy the link to send for review." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Account avatar tooltip (Japanese audience) */
            ACCOUNT_MULTI_LANGUAGE: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for account avatar tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.ACCOUNT_MULTI_LANGUAGE.title?c=3g5tr9u4qkupo", defaultMessage: "Frame.io is now available in more languages." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for account avatar tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.ACCOUNT_MULTI_LANGUAGE.description?c=5v4t0wgys55k", defaultMessage: "Switch anytime using the language picker in account settings." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Mount project button tooltip */
            MOUNT_PROJECT_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for mount project button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.MOUNT_PROJECT_BUTTON.title?c=2omzjeliboz3u", defaultMessage: "Work locally with Frame.io Drive" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for mount project button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.MOUNT_PROJECT_BUTTON.description?c=2kt8ypegudy87", defaultMessage: "Open projects directly on your desktop." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Link label for mount project button tooltip */
                        linkLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.MOUNT_PROJECT_BUTTON.linkLabel?c=2bu5tw74q9bww", defaultMessage: "Learn more" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Enable Mounted Storage button tooltip */
            ENABLE_MOUNTED_STORAGE_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for enable mounted storage button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.ENABLE_MOUNTED_STORAGE_BUTTON.title?c=3w38qb9g8wp03", defaultMessage: "Let your team work locally with Frame.io Drive" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for enable mounted storage button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.ENABLE_MOUNTED_STORAGE_BUTTON.description?c=174uh0xbyvopr", defaultMessage: "Enable Mounted Storage to let members with edit access or higher open projects directly on their desktops with Frame.io Drive." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Labs nav item tooltip */
            LABS_NAV: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for labs nav tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.LABS_NAV.title?c=ptohy778nyor", defaultMessage: "Shape what''s next with Frame.io Labs" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for labs nav tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.LABS_NAV.description?c=2aqape1kxijiy", defaultMessage: "Get early access to experimental features and share feedback to help improve what we''re building." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Link label for labs nav tooltip */
                        linkLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.LABS_NAV.linkLabel?c=2bu5tw74q9bww", defaultMessage: "Learn more" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Export sequence button tooltip in Premiere Pro sequences tab */
            EXPORT_SEQUENCE_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for export sequence button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.EXPORT_SEQUENCE_BUTTON.title?c=2yyhyvl58dkh5", defaultMessage: "Export your sequence to Frame.io." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for export sequence button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.EXPORT_SEQUENCE_BUTTON.description?c=1h8n19skz7f25", defaultMessage: "Upload sequences so you can share them for review without leaving Premiere." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Export composition button tooltip in After Effects compositions tab */
            EXPORT_COMPOSITION_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for export composition button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.EXPORT_COMPOSITION_BUTTON.title?c=1wqxdhwodu6p4", defaultMessage: "Export your render queue to Frame.io." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for export composition button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.EXPORT_COMPOSITION_BUTTON.description?c=24hoiy2pibe88", defaultMessage: "Upload compositions so you can share them for review without leaving After Effects." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share sequence button tooltip in Premiere Pro sequences tab */
            SHARE_SEQUENCE_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share sequence button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_SEQUENCE_BUTTON.title?c=1v4fcrhe2a9j7", defaultMessage: "Share your sequence for review" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share sequence button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_SEQUENCE_BUTTON.description?c=lpwxxqhyzkun", defaultMessage: "Anyone with the link can watch and comment." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Share composition button tooltip in After Effects compositions tab */
            SHARE_COMPOSITION_BUTTON: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for share composition button tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMPOSITION_BUTTON.title?c=17lsjabptqpv5", defaultMessage: "Share your composition for review" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description for share composition button tooltip */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_COMPOSITION_BUTTON.description?c=lpwxxqhyzkun", defaultMessage: "Anyone with the link can watch and comment." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Save as list button tooltip in the quickshare modal */
            SHARE_LIST: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Tooltip heading for the Save as list button in the share modal */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_LIST.title?c=20701fo5s9037", defaultMessage: "Speed Up Sharing" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Tooltip body explaining that share lists let you invite multiple collaborators at once */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_LIST.description?c=bhhr6syr12q6", defaultMessage: "Use lists to invite collaborators to a Share Link at one time." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Button label to dismiss the Save as list tooltip */
                        actionLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.SHARE_LIST.actionLabel?c=26ns0v4lhnziz", defaultMessage: "Got it" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Create upload link button tooltip in the finder bottom bar */
            CREATE_UPLOAD_LINK: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the create upload link tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.CREATE_UPLOAD_LINK.title?c=5u231tt89cn", defaultMessage: "Let anyone upload directly to a folder" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description explaining what upload links do */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.CREATE_UPLOAD_LINK.description?c=hyqili6ruc5o", defaultMessage: "Share an Upload Link and let freelancers, vendors, or clients drop files straight into the right folder. Secure and ready to go \u2014 no account needed." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Button label to dismiss the create upload link tooltip */
                        actionLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.CREATE_UPLOAD_LINK.actionLabel?c=3kgms7gn8i2kv", defaultMessage: "OK" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Discovery tooltip pointing at the first editable shortcut in the help dialog */
            CUSTOM_SHORTCUTS_CAPTURE: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the custom-shortcuts discovery tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.CUSTOM_SHORTCUTS_CAPTURE.title?c=3qbirdkxfmxo1", defaultMessage: "Customize your shortcuts" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description explaining how to edit a shortcut inline */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.CUSTOM_SHORTCUTS_CAPTURE.description?c=3saupvbdo1vwt", defaultMessage: "Hover over any row to edit or clear a shortcut. Reset to defaults any time." }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Version history discovery tooltip anchored to the version pill in the viewer */
            VERSION_HISTORY: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the version history tooltip */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.VERSION_HISTORY.title?c=2efg566wyeipq", defaultMessage: "See All Saves" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Description explaining that Frame.io Drive saves appear in version history */
                        description: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.VERSION_HISTORY.description?c=2wzsadecr1xex", defaultMessage: "Every save from Frame.io Drive appears in Version History." }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Button label that opens the version history modal */
                        viewHistoryLabel: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Tooltips.VERSION_HISTORY.viewHistoryLabel?c=2xdqmjl2axegb", defaultMessage: "View Version History" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
